/*
 * KRYO — compact reimplementation of the source theme's <product-card> orchestration
 * (the original lives inside the 500KB cart-487.js/js.js bundles). Reproduces only the
 * behaviour the ported sub-components rely on:
 *   - holds the variant list,
 *   - reflects the selected variant id onto `data-product-card-selected_variant_id`
 *     (observed by <product-gallery-487> and <buy-buttons> via MutationObserver),
 *   - the per-variant wrappers (title/price/desc/specs) show/hide purely via the inline
 *     `[data-product-card-selected_variant_id='X'] .wrapper-X` CSS, so we only set the attr,
 *   - updates option chips (selected + unavailable) and the ?variant= URL param.
 */
class KryoProductCard extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector('[data-variants]');
    try { this.variants = JSON.parse(data.textContent); } catch (e) { this.variants = []; }
    this.inputs = Array.from(this.querySelectorAll('[data-option-value]'));
    this.inputs.forEach((i) => i.addEventListener('change', () => this.onChange()));
    this.onChange(true);
  }
  get selectedOptions() {
    const m = {};
    this.inputs.forEach((i) => { if (i.checked) m[i.dataset.optionValue] = i.value; });
    return m;
  }
  findVariant(map) {
    const sel = map || this.selectedOptions;
    const keys = Object.keys(sel);
    if (!keys.length) return this.variants[0];
    return this.variants.find((v) => keys.every((k) => v.options[Number(k)] === sel[k]));
  }
  onChange(initial) {
    this.markUnavailable();
    const v = this.findVariant();
    if (!v) return;
    this.current = v;
    this.setAttribute('data-product-card-selected_variant_id', v.id);
    // reflect selected option value labels
    Object.entries(this.selectedOptions).forEach(([idx, val]) => {
      const lbl = this.querySelector(`[data-option-selected="${idx}"]`);
      if (lbl) lbl.textContent = val;
    });
    // keep any cart-form hidden id in sync
    const idInput = this.querySelector('[data-variant-id-input]');
    if (idInput) idInput.value = v.id;
    if (!initial && window.history && v.id) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
    this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
  }
  markUnavailable() {
    const sel = this.selectedOptions;
    this.inputs.forEach((input) => {
      const idx = Number(input.dataset.optionValue);
      const test = Object.assign({}, sel); test[idx] = input.value;
      const match = this.findVariant(test);
      const label = input.nextElementSibling;
      if (label) {
        label.classList.toggle('is-unavailable', !(match && match.available));
        label.classList.toggle('opacity-40', !(match && match.available));
      }
    });
  }
}
if (!customElements.get('product-card')) customElements.define('product-card', KryoProductCard);
